import { dataApiUrl } from './url';
import axios from 'axios';

const DataApiUrl = dataApiUrl();
const Axios = axios.create({
  baseURL: DataApiUrl,
});

Axios.defaults.headers.common = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

Axios.interceptors.request.use(
  config => {
    config.headers['Authorization'] = `Bearer ${localStorage.getItem('scale_music_auth0_token')}`;

    return config;
  },
  error => Promise.reject(error)
);

export default Axios;
